import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status"]
  static values = { url: String }

  submit(event) {
    event.preventDefault()
    const card = document.activeElement.closest(".admin-photo-column")
    if (card) this.saveMetadata({ currentTarget: card })
  }

  upload(event) {
    const input = event.currentTarget
    if (!input.files.length || !input.reportValidity()) return
    const body = new FormData()
    Array.from(input.files).forEach(file => body.append("service[new_images][]", file))
    this.save(body, { upload: true })
  }

  saveMetadata(event) {
    const card = event.currentTarget.closest(".admin-photo-column")
    const body = new FormData()
    card.querySelectorAll("input[name$='[id]'], input[name$='[alt]'], textarea[name$='[description]'], input[name$='[position]']").forEach(input => body.set(input.name, input.value))
    this.save(body, { replaceId: card.dataset.photoId })
  }

  destroy(event) {
    if (!window.confirm("Удалить фотографию безвозвратно? Если это обложка, она также будет убрана.")) return
    const body = new FormData()
    body.set("service[photos_attributes][0][id]", event.currentTarget.dataset.photoId)
    body.set("service[photos_attributes][0][_destroy]", "1")
    this.save(body)
  }

  cover(event) {
    const body = new FormData()
    body.set("service[cover_photo_id]", event.currentTarget.dataset.photoId)
    this.save(body)
  }

  gallery(event) {
    const button = event.currentTarget
    const body = new FormData()
    body.set("service[photos_attributes][0][id]", button.dataset.photoId)
    body.set("service[photos_attributes][0][show_in_gallery]", button.getAttribute("aria-checked") === "true" ? "0" : "1")
    this.save(body)
  }

  async save(body, options = {}) {
    if (this.saving) return
    this.saving = true
    this.statusTarget.textContent = options.upload ? "Загружаем фотографии…" : "Сохраняем…"
    const buttons = this.element.querySelectorAll("button[data-photo-id], input[type='file']")
    buttons.forEach(button => { button.disabled = true })
    this.abort = new AbortController()
    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH", body, signal: this.abort.signal,
        headers: { Accept: "application/json", "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || "" }
      })
      if (response.redirected || !response.headers.get("content-type")?.includes("application/json")) throw new Error("Не удалось сохранить. Проверьте вход в аккаунт.")
      const result = await response.json()
      if (!response.ok) throw new Error(result.error || "Не удалось сохранить фотографию.")
      const anchorTop = this.element.getBoundingClientRect().top
      document.querySelector("#service-cover").innerHTML = result.cover_html
      document.querySelector("#service-gallery").innerHTML = result.gallery_html
      this.syncCards(result, options.replaceId)
      // Изменение галереи выше формы не должно сдвигать текущую миниатюру.
      window.scrollBy(0, this.element.getBoundingClientRect().top - anchorTop)
      this.element.querySelectorAll("input[type='radio'][name='service[cover_photo_id]']").forEach(input => {
        input.checked = input.value === String(result.cover_photo_id || "")
      })
      this.element.querySelectorAll(".photo-cover-button").forEach(button => {
        const active = button.dataset.photoId === String(result.cover_photo_id)
        button.classList.toggle("btn-primary", active)
        button.classList.toggle("btn-outline-primary", !active)
        button.setAttribute("aria-pressed", String(active))
        button.textContent = active ? "Обложка" : "На обложку"
      })
      result.photos.forEach(photo => {
        const button = this.element.querySelector(`.photo-gallery-toggle[data-photo-id='${photo.id}']`)
        if (!button) return
        button.classList.toggle("is-enabled", photo.show_in_gallery)
        button.setAttribute("aria-checked", String(photo.show_in_gallery))
        button.closest(".admin-photo-card").querySelector("input[name$='[show_in_gallery]']").value = photo.show_in_gallery ? "1" : "0"
      })
      if (options.upload) {
        const input = this.element.querySelector("input[type='file']")
        input.value = ""
        input.dispatchEvent(new Event("change", { bubbles: true }))
      }
      this.statusTarget.textContent = options.upload ? "Фотографии загружены." : "Сохранено."
    } catch (error) {
      if (error.name !== "AbortError") this.statusTarget.textContent = error.message
    } finally {
      this.saving = false
      buttons.forEach(button => { button.disabled = false })
      const cover = this.element.querySelector(".photo-cover-button[aria-pressed='true']")?.dataset.photoId
      this.element.querySelectorAll(".photo-gallery-toggle").forEach(button => {
        button.disabled = button.dataset.photoId === cover
        button.title = button.disabled ? "Обложка не дублируется в галерее" : "Показывать в галерее"
      })
    }
  }

  syncCards(result, replaceId) {
    const template = document.createElement("template")
    template.innerHTML = result.manager_html
    const grid = this.element.querySelector(".photo-card-grid")
    const ids = result.photos.map(photo => String(photo.id))
    grid.querySelectorAll(".admin-photo-column").forEach(card => {
      if (!ids.includes(card.dataset.photoId)) card.remove()
    })
    template.content.querySelectorAll(".admin-photo-column").forEach(card => {
      const existing = grid.querySelector(`.admin-photo-column[data-photo-id='${card.dataset.photoId}']`)
      if (!existing) {
        grid.append(card)
      } else if (card.dataset.photoId === replaceId) {
        card.querySelector("details").open = existing.querySelector("details").open
        existing.replaceWith(card)
      }
    })
  }

  disconnect() { this.abort?.abort() }
}
